/*
 * @Author: seven 
 * @Date: 2020-10-29 16:05:08 
 * @Last Modified by: seven
 * @Last Modified time: 2020-10-30 16:36:05
 */
class NodeModel {
    constructor(name, checked = false) {
        this.sName = name;
        this.checked = checked
        this.aChildren = [];
    }
    getCheckedData(data = this.aChildren) {
        let nodes = data.filter(i => i.isChecked());
        let array = nodes.map(node => {
            let obj = {
                sName: node.sName
            }
            if(node.aChildren && node.aChildren.length){
                obj.aChildren = this.getCheckedData(node.aChildren)
            }
            return obj
        });
        return array;
    }
    loadData(list) {
        delete this.checked;
        list.forEach(item => {
            let node = new NodeModel(item.sName,item.checked);
            if(item.aChildren && item.aChildren.length) {
                node.loadData(item.aChildren);
            }
            this.aChildren.push(node);
        });
    }
    isChecked() {
        if (this.aChildren.length) {
            if (this.isChildrenAllUnChecked()) {
                return false;
            } else {
                return true;
            }
        } else {
            return this.checked;
        }
    }
    isIndeterminate() {
        if(this.isChildrenAllUnChecked()) {
            return false;
        }
        let hasUnchecked = this.aChildren.find(s => {
            if(!s.isChecked()) {
                return true;
            }
            if(s.isIndeterminate()) {
                return true;
            }
        });
        return !!hasUnchecked;
    }
    setChecked(isChecked) {
        this.checked = isChecked;
        if (this.aChildren.length) {
            this.aChildren.forEach(c => {
                c.setChecked(isChecked);
            });
        }
    }
    isChildrenAllUnChecked() {
        // if(!this.aChildren || this.aChildren.length == 0) return true
        let hasChecked = this.aChildren.find(c => {
            if(c.checked) {
                return true;
            }
            return !c.isChildrenAllUnChecked();
        });
        return !hasChecked;
    }
}
export default NodeModel